import { FC, useMemo, useContext, PropsWithChildren } from 'react';
import useParticipants from '@/hooks/data/useParticipants';
import ParticipantContext, { IParticipantContext } from '@/contexts/data/ParticipantContext';
import IsLoading from '@/components/layouts/IsLoading';
import { useMatch, useParams } from 'react-router-dom';
import ParticipantsContext from '@/contexts/data/ParticipantsContext';


export interface IParticipantProviderProps {
}

export const ParticipantProvider: FC<PropsWithChildren<IParticipantProviderProps>> = ({ children }) => {
    const participants = useContext(ParticipantsContext);

    const studyNumber = useParams()?.studyNumber;

    const participant  = useMemo(() => {
        if (!studyNumber) {
            return {
                data: undefined,
                error: undefined,
                loading: false,
                validating: false,
                refresh: async () => {
                    return undefined;
                },
            } as IParticipantContext;
        }

        return {
            data: participants.data?.find(x => x.studyNumber === studyNumber),
            code: studyNumber,
            error: participants.error,
            loading: participants.loading,
            validating: participants.validating,
            refresh: async () => {
                const newData = await participants.refresh();

                return newData?.find(x => x.studyNumber === studyNumber);
            },
        } as IParticipantContext
    }, [participants, studyNumber]);

    return (

        <ParticipantContext.Provider value={participant}>
            <IsLoading name="participant" loading={participant.loading} validating={participant.validating}/>
            {children}
        </ParticipantContext.Provider>
    );
}

export default ParticipantProvider;
